import * as React from 'react';

import { cn } from '@/components/TailwindComponents/lib/utils';

interface PageContentProps {
  children: React.ReactNode;
  className?: string;
}

export const PageContent: React.FC<PageContentProps> = ({
  children,
  className,
}) => {
  return <div className={cn('flex-1 h-full', className)}>{children}</div>;
};
